import { Injectable } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CrudHelper } from 'src/app/firebase/helpers/crudHelper';
import { CommonService } from 'src/app/shared/component-store/common-service';

@Injectable({ providedIn: 'root' })
export class CommunityService extends CommonService {
  isOpenForm = new BehaviorSubject(false);
  allUsers$ = new BehaviorSubject([]);

  constructor(
    private fb: FormBuilder,
    private firebaseHelperService: CrudHelper
  ) {
    super(firebaseHelperService);
  }

  addImage(images) {
    let i = images.length;
    i = this.fb.group({
      image: [null],
    });
    images.push(i);
  }

  deleteImage(images: FormArray, i: number) {
    images.removeAt(i);
  }

  getProfile(email: string) {
    return this.firebaseHelperService.searchByField('users', 'email', email);
  }

  getItems({ collectionName, filter }) {
    const queryFn = ref => {
      let query = ref;

      const { country, experience, gender, followers, following } = filter;

      if (country && country.length > 0) {
        query = query.where('country', 'in', country);
      }

      if (gender && gender.length > 0) {
        query = query.where('gender', 'in', gender);
      }

      if (experience && experience.length > 0) {
        query = query.where('mermaidExpLvl', 'in', experience);
      }

      if (followers && followers.length > 0) {
        query = query.where('uid', 'in', followers);
      }

      if (following && following.length > 0) {
        query = query.where('uid', 'in', following);
      }
      // TODO check why this method doesn't work
      // query = query.orderBy('username', 'asc');

      return query;
    };

    return this.firebaseHelperService.getCollectionItems({
      collectionName,
      queryFn,
    });
  }

  checkFilter(filter) {
    const { experience, country, gender, myContent } = filter;
    const result =
      filter === false ||
      ((experience === null || !experience?.length) &&
        (country === null || !country?.length) &&
        (gender === null || !gender?.length) &&
        !myContent);
    return !result;
  }
}
